export const changingRowColor = (a: number = 0, b: number = 0) => {
  if (a === null || b === null || a === undefined || b === undefined)
    return false;
  return a <= b ? true : false;
};
